import { Component, OnInit } from '@angular/core';
import { IBasicInfo } from '../../../../fundraiser/models/fundraiser.model';

@Component({
  selector: 'app-updates-social-share',
  templateUrl: './updates-social-share.component.html',
  styleUrls: ['./updates-social-share.component.scss']
})
export class UpdatesSocialShareComponent implements OnInit {
  campaign_url;
  updatesSummary;
  basicInfo = {} as IBasicInfo;
  isFundraiserEnded;
  utm_params;
  sharedCounts;
  constructor() { }

  ngOnInit() {
  }

}
